import React from "react";
import { StyledButton, StyledPrimaryButton, StyledSecondaryButton } from "../../styled";
import { useBulletinDetails } from "../../context";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import Box from "@mui/material/Box";

const ActionButton = () => {
  const {
    disabled,
    handleSaveDraft,
    handleSaveActive,
    handleSaveTranslations,
    isSubmittingBulletin,
  } = useBulletinDetails();

  const { allowed: hasWriteAccess } = useRolePermission("bulletinBoard:write");
  const { allowed: hasWriteTranslationsAccess } = useRolePermission("bulletinBoard:translations:write");

  if (!hasWriteAccess && !hasWriteTranslationsAccess) {
    return null;
  }

  if (!hasWriteAccess && hasWriteTranslationsAccess) {
    return (
      <Box>
        <StyledButton
          title="Save"
          size="small"
          onClick={handleSaveTranslations}
          loading={isSubmittingBulletin}
        />
      </Box>
    );
  }

  return (
    <Box
      gap="1rem"
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <StyledSecondaryButton
        title="Save as draft"
        size="small"
        color="secondary"
        variant="outlined"
        disabled={disabled}
        onClick={handleSaveDraft}
        loading={isSubmittingBulletin}
      />
      <StyledPrimaryButton
        title="Save and Publish"
        size="small"
        disabled={disabled}
        onClick={handleSaveActive}
        loading={isSubmittingBulletin}
      />
    </Box>
  );
};

export default ActionButton;